<template>
  <div class="user-main">
    <div class="user-main-head">
      <img data-track-text="返回账号设置" @click="clickHandler('/account')" style="margin-left: 28px" src="../assets/go-back.png" alt=""/>
      <div>邮箱修改</div>
    </div>
    <div class="main-login-form">
      <div class="main-login-form-input">
        <el-form label-width="0" class="demo-ruleForm" :model="updateEmailForm" :rules="email_rules" ref="emailRef">
          <el-form-item prop="email">
            <el-input placeholder="请输入邮箱" v-model="updateEmailForm.email"></el-input>
          </el-form-item>
          <el-form-item prop="code" class="split-row">
            <el-input style="width: 475px;" placeholder="请输入4位验证码" v-model="updateEmailForm.code"></el-input>
            <img
              style=" border-radius: 3px;float: right;width: 133px;height: 62px;font-family: Noto Sans S Chinese !important;"
              :src="qrcodeUrl" alt="验证码加载失败..."
              data-track-text="刷新邮箱验证码" @click="getValicode"/>
          </el-form-item>
          <el-form-item prop="newEmailCode" class="split-row">
            <el-input style="width: 475px;" placeholder="请输入6位新邮箱验证码" v-model="updateEmailForm.newEmailCode"
            ></el-input>
            <div class="timeButton" data-track-text="获取邮箱动态密码" v-show="Verification" @click="handleEmailTimeClick">获取动态密码</div>
            <div class="timeButtonClick" v-show="!Verification">{{ timers }}秒后重新获取</div>
          </el-form-item>
          <div class="form-message" style="text-align: center;font-size: 24px;color: #df2525;font-family: Noto Sans S Chinese !important;">{{ messages }}</div>
          <el-form-item class="login_button">
            <el-button type="primary" data-track-text="确认修改邮箱" @click="submitUpdateEmail()">确认修改</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import {redirectToMainLogin} from '@/utils/responsive'

export default {
  name: "ReEmail",
  data() {
    return {
      messages: '',
      timers: 60,
      Verification: true,
      qrcodeUrl: "",
      updateEmailForm: {
        email: undefined,
        code: undefined,
        newEmailCode: undefined,
      },
      email_rules: {
        email: [
          {required: true, message: '请输入新邮箱', trigger: 'blur'},
          {pattern:  /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/, message: "请输入合法邮箱", trigger: "blur"},
          {validator: this.validateEmail, trigger: 'blur'}
        ],
        code: [
          {required: true, message: '请输入验证码', trigger: 'blur'},
          {min: 4, max: 4, message: '请输入4位验证码', trigger: 'blur'}
        ],
        newEmailCode: [
          {validator: this.validateNewEmailCode, trigger: 'blur'}
        ]
      },
    }
  },
  mounted() {
    this.getValicode()
  },
  methods: {
    handleEmailTimeClick() {
      this.$track('email_code_send_submit', {source: 'mobile_page'})
      this.$refs.emailRef.validate((valid) => {
        if (!valid) {
          this.$track('email_code_send_result', {result: 'validation_failed', source: 'mobile_page'})
          return;
        }
        const that = this;
        this.$http.get('/api/account/sendEmailCode?email=' + that.updateEmailForm.email + "&code=" + that.updateEmailForm.code).then(res => {
          if (res.data) {
            that.$track('email_code_send_result', {result: 'success', source: 'mobile_page'})
            that.messages = "";
            that.Verification = false;
            this.auth_timer = setInterval(() => {
              that.timers--;
              if (that.timers <= 0) {
                that.Verification = true;
                that.timers = 60;
                clearInterval(that.auth_timer)
              }
            }, 1000)
            return;
          }
          that.$track('email_code_send_result', {result: 'failure', reason: 'captcha_rejected', source: 'mobile_page'})
          that.getValicode();
          that.messages = "验证码错误"
          that.Verification = true;
          that.timers = 60;
        }).catch(err => {
          that.$track('email_code_send_result', {result: 'failure', reason: 'request_failed', source: 'mobile_page'})
          that.getValicode();
          that.messages = "邮箱验证码发送失败"
          that.Verification = true;
          that.timers = 60;
        });
      });
    },
    validateNewEmailCode(rule, value, callback) {
      if (!this.isLogin) {
        callback()
        return
      }
      if (value === null || value === undefined || value === "") {
        callback(new Error('请输入新邮箱验证码'))
        return;
      }
      if (value.length > 6 || value.length < 6) {
        callback(new Error('请输入6位新邮箱验证码'))
        return;
      }
      callback()
    },
    validateEmail(rule, value, callback) {
      if(this.email===value.trim()){
        callback(new Error('邮箱与原邮箱一致'))
        return;
      }
      this.$http.get("/api/account/validateEmail?email=" + value).then(res => {
        if (res.data === 400) {
          callback(new Error('邮箱有误'))
          return;
        }
        if (res.data === 401) {
          callback(new Error('邮箱已被绑定'))
          return;
        }
        callback()
      }).catch(err => {
        callback(new Error('校验出错'));
      });
    },
    submitUpdateEmail() {
      this.isLogin = true;
      const that = this
      this.$track('account_email_update_submit', {source: 'mobile_page'})
      this.$refs.emailRef.validate((valid) => {
        if (!valid) {
          this.$track('account_email_update_result', {result: 'validation_failed', source: 'mobile_page'})
          return;
        }
        this.$http.post("/api/account/updateEmail",{
          "email":this.updateEmailForm.email,
          "code":this.updateEmailForm.code,
          "newCode":this.updateEmailForm.newEmailCode
        }).then(res => {
          if (res.data === 200) {
            that.$track('account_email_update_result', {result: 'success', source: 'mobile_page'})
            that.isLogin = false;
            that.updateEmail = false
            that.$message.success("更新成功")
            this.$router.push("/account")
            return;
          }
          that.$track('account_email_update_result', {result: 'failure', source: 'mobile_page'})
          that.messages = "更新失败请重试！";
          that.getValicode();
          that.isLogin = false;
        }).catch(err => {
          that.$track('account_email_update_result', {result: 'failure', reason: 'request_failed', source: 'mobile_page'})
          if (err && err.code === 5) {
            redirectToMainLogin()
          }
          that.isLogin = false;
        })
      });
      this.isLogin = false;
    },
    getValicode() {
      this.qrcodeUrl = '/api/account/getValicode?' + new Date();
    },
    clickHandler(url) {
      this.$router.push(url)
    },
  }
}
</script>

<style lang="less" scoped>
.timeButton {
  border-radius: 3px;
  cursor: pointer;
  white-space: nowrap;
  padding: 10px 20px;
  border: 0px solid #000;
  width: 94px;
  height: 45px;
  float: right;
  background-color: #efeded;
  font-size: 21px;
  font-weight: 400;
  font-family: Noto Sans S Chinese !important;
  color: #333333;
  display: flex;
  justify-content: center;
}

.timeButtonClick {
  border-radius: 3px;
  cursor: pointer;
  white-space: nowrap;
  padding: 10px 20px;
  border: 0px solid #000;
  width: 94px;
  height: 45px;
  float: right;
  background-color: #0c7dba;
  font-size: 18px;
  font-weight: 400;
  font-family: Noto Sans S Chinese !important;
  display: flex;
  justify-content: center;
  color: #ffffff;
}

.main-login-form {
  width: 704px;
  height: 1000px;
  background: #FFFFFF;
  margin-top: 30px;
  margin-bottom: 30px;

  .main-login-form-input {
    padding-top: 50px;
    width: 625px;
    display: flex;
    justify-content: center;

    /deep/ .demo-ruleForm {
      .el-form-item.is-error .el-input__inner, .el-form-item.is-error .el-input__inner:focus, .el-form-item.is-error .el-textarea__inner, .el-form-item.is-error .el-textarea__inner:focus {
        height: 65px;
        border: 1px solid #FBAFAF;
        box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.05);
        border-radius: 3px;
      }

      .el-button--primary {
        width: 624px;
        height: 70px;
        background: #063f95;
        border-radius: 3px;
        margin-top: 31px;
        font-size: 30px;
        font-family: Adobe Heiti Std;
        font-weight: normal;
        color: #FFFFFF;
      }

      .el-form-item__error {
        color: #F56C6C;
        font-size: 20px;
        line-height: 1;
        padding-top: 4px;
        position: absolute;
        top: 100%;
        left: 0;
      }

      .el-form-item {
        margin-bottom: 31px;
      }

      .el-form-item__content {
        margin-left: 76px !important;
      }

      .el-input {
        height: 65px;
        width: 625px;

        .el-input__inner {
          height: 65px;
          border: 1px solid #DDDDDD;
          box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.05);
          border-radius: 3px;
          font-size: 24px;
        }
      }
    }
  }
}

.user-main {
  min-width: 765px;
  width: 100%;
  background: #f5f5f5;
  display: flex;
  flex-flow: column;
  align-items: center;
  overflow-x: hidden;
}

.user-main-head {
  width: 100%;
  height: 88px;
  background: #E6E6E6;
  display: flex;
  align-items: center;
}

.user-main-head div {
  flex: 1;
  font-size: 24px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
  text-align: center;
  margin-right: 60px;
}

@media (max-width: 768px) {
  .user-main {
    min-width: 0;
    width: 100%;
    max-width: 100vw;
    overflow-x: hidden;
    box-sizing: border-box;
  }

  .user-main-head {
    width: 100%;
    height: 56px;
    padding: 0 12px;
    box-sizing: border-box;
  }

  .user-main-head > img {
    width: 20px;
    height: 20px;
    margin-left: 0 !important;
    object-fit: contain;
  }

  .user-main-head div {
    margin-right: 20px;
    font-size: 17px;
  }

  .main-login-form {
    width: calc(100% - 24px);
    max-width: 100%;
    height: auto;
    min-height: calc(100vh - 92px);
    margin: 12px;
    padding: 28px 16px 96px;
    box-sizing: border-box;

    .main-login-form-input {
      width: 100%;
      max-width: 100%;
      padding-top: 0;
      display: block;
    }

    /deep/ .demo-ruleForm {
      width: 100%;
      max-width: 100%;

      .el-form-item {
        width: 100%;
        margin-bottom: 22px;
      }

      .el-form-item__content {
        width: 100%;
        margin-left: 0 !important;
      }

      .el-input {
        width: 100% !important;
        height: 44px;

        .el-input__inner {
          width: 100%;
          height: 44px;
          box-sizing: border-box;
          font-size: 15px;
        }
      }

      .el-form-item.is-error .el-input__inner,
      .el-form-item.is-error .el-input__inner:focus {
        height: 44px;
      }

      .el-form-item__error {
        grid-column: 1 / -1;
        font-size: 12px;
        line-height: 16px;
      }

      .split-row .el-form-item__content {
        display: grid;
        grid-template-columns: minmax(0, 1fr) 104px;
        align-items: start;
        gap: 8px;
      }

      .split-row img {
        width: 104px !important;
        max-width: 100%;
        height: 44px !important;
        float: none !important;
        object-fit: cover;
      }

      .el-button--primary {
        width: 100%;
        height: 44px;
        margin-top: 16px;
        font-size: 16px;
      }
    }
  }

  .timeButton,
  .timeButtonClick {
    width: 104px;
    max-width: 100%;
    height: 44px;
    padding: 0 4px;
    float: none;
    align-items: center;
    box-sizing: border-box;
    font-size: 13px;
    line-height: 18px;
    text-align: center;
  }

  .form-message {
    font-size: 13px !important;
    line-height: 20px;
    overflow-wrap: anywhere;
  }

  .main-login-form .main-login-form-input {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
    box-sizing: border-box;
  }

  .main-login-form .main-login-form-input /deep/ .demo-ruleForm,
  .main-login-form .main-login-form-input /deep/ .demo-ruleForm .el-form-item,
  .main-login-form .main-login-form-input /deep/ .demo-ruleForm .el-form-item__content,
  .main-login-form .main-login-form-input /deep/ .demo-ruleForm .el-input,
  .main-login-form .main-login-form-input /deep/ .demo-ruleForm .el-input__inner {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
    box-sizing: border-box;
  }

  .main-login-form .main-login-form-input /deep/ .demo-ruleForm .el-form-item__content {
    margin-left: 0 !important;
  }

  .main-login-form .main-login-form-input /deep/ .demo-ruleForm .el-button--primary {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
    height: 44px !important;
    box-sizing: border-box;
  }

  .main-login-form .main-login-form-input /deep/ .demo-ruleForm .split-row .el-form-item__content {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 104px;
    gap: 8px;
  }
}
</style>
